import React, {useState} from 'react';
import {settingsText} from '../../settingsText';
import {Col, Row} from 'react-bootstrap';
import './styles.css';
import TextInput from '../../../../uiToolkit/Inputs/TextInput';
import {formatDateTimeTextFormat} from '../../../../utils/notificationTimeTextConvertor';
import {
  getSubscriptionNameFromTier,
  OrganizationSubscription,
  SUBSCRIPTION_STATUS_ACTIVE,
  SUBSCRIPTION_STATUS_CANCELLED,
  SUBSCRIPTION_STATUS_ENDED,
} from '../../../../data/models/Subscription/Subscription';
import InvoicesTable from '../components/InvoicesTable';
import ActionsSection from '../components/ActionsSection';
import SubscriptionPlanCard from '../../../../uiToolkit/SubscriptionPlanCard/SubscriptionPlanCard';
import {availableSubscriptionPlans} from '../config';
import {
  SUBSCRIPTION_TRIAL,
  SUBSCRIPTION_ENTERPRISE,
  isSameSubscription,
  isAnnualSubscription,
} from '../../../Subscription/config';
import Toggle, {ToggleValue} from '../../../../uiToolkit/Inputs/Toggle/Toggle';

interface Props {
  onSelectSubscription: (tier?: number) => void;
  subscription: OrganizationSubscription;
  onCancelSubscription: () => void;
  onChangePaymentMethod: () => void;
  invoices: any[];
  isLoading: boolean;
  onShowFullList: () => void;
}

const SubscriptionSettingsUI = React.memo(
  ({
    subscription,
    onCancelSubscription,
    onChangePaymentMethod,
    onSelectSubscription,
    invoices,
    isLoading,
    onShowFullList,
  }: Props) => {
    const [isAnnual, setIsAnnual] = useState<ToggleValue>(
      isAnnualSubscription(subscription.type) ? 'right' : 'left',
    );

    const isSubscriptionCancelled =
      subscription.cancelAtPeriodEnd &&
      subscription.type !== SUBSCRIPTION_TRIAL &&
      (subscription.organizationSubscriptionStatus ===
        SUBSCRIPTION_STATUS_ACTIVE ||
        subscription.organizationSubscriptionStatus ===
          SUBSCRIPTION_STATUS_CANCELLED);
    const isSubscriptionEnded =
      subscription.organizationSubscriptionStatus ===
        SUBSCRIPTION_STATUS_ENDED && subscription.type !== SUBSCRIPTION_TRIAL;
    return (
      <div className="SubscriptionSettingsContainer">
        {subscription && subscription.type !== 3 && (
          <Row>
            <Col xs={12}>
              <Toggle
                leftText="Monthly"
                rightText="Annual"
                selectedValue={isAnnual}
                onChange={setIsAnnual}
              />
            </Col>
          </Row>
        )}
        <Row>
          <Col xs={12}>
            <div className="d-flex flex-row justify-content-center align-items-center">
              {availableSubscriptionPlans(subscription.type).map(
                (plan, index) => (
                  <SubscriptionPlanCard
                    plan={plan}
                    onClick={onSelectSubscription}
                    key={index.toString()}
                    onShowFullList={onShowFullList}
                    isCurrentPlan={isSameSubscription(
                      plan.id,
                      subscription.type,
                      true,
                    )}
                    currentSubscriptionId={subscription.type}
                    isEnterprise={plan.id === SUBSCRIPTION_ENTERPRISE}
                    expired={
                      subscription.organizationSubscriptionStatus !==
                      SUBSCRIPTION_STATUS_ACTIVE
                    }
                    isAnnualView={isAnnual == 'right'}
                  />
                ),
              )}
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6}>
            <div className="subscriptionInputContainer">
              <h3>{settingsText.subscriptionTier}</h3>
              <TextInput
                value={getSubscriptionNameFromTier(subscription.type) || ''}
                //heading={settingsText.subscriptionTier}
                onChange={() => {
                  //nothing
                }}
                placeholder=""
                className="SubscriptionField"
                noEdit
              />
            </div>
            {!isSubscriptionCancelled &&
              !isSubscriptionEnded &&
              subscription.type !== SUBSCRIPTION_TRIAL && (
                <div className="subscriptionInputContainer">
                  <h3>{settingsText.expirationDate}</h3>
                  <TextInput
                    value={formatDateTimeTextFormat(
                      subscription.currentPeriodEndDate,
                    )}
                    //heading={settingsText.expirationDate}
                    onChange={() => {
                      //nothing
                    }}
                    placeholder=""
                    className="SubscriptionField"
                    noEdit
                  />
                </div>
              )}
            {isSubscriptionCancelled && !isSubscriptionEnded && (
              <div className="CancelledSubscriptionText">
                {settingsText.subscriptionCancelledMessage(
                  formatDateTimeTextFormat(subscription.currentPeriodEndDate),
                )}
              </div>
            )}
            {isSubscriptionEnded && !isSubscriptionCancelled && (
              <div className="CancelledSubscriptionText">
                {settingsText.subscriptionCancelledMessage(
                  settingsText.subscriptionExpiredMessage,
                )}
              </div>
            )}
            {/* {subscription?.last4 && (
              <TextInput
                value={`****_****_****_${subscription.last4}`}
                heading={settingsText.cardDetails}
                onChange={() => {
                  //nothing
                }}
                placeholder=""
                className="SubscriptionField"
                noEdit
              />
            )} */}
          </Col>
          <Col xs={12}>
            <InvoicesTable invoices={invoices} isLoading={isLoading} />
            <ActionsSection
              onCancelSubscription={
                !subscription.cancelAtPeriodEnd &&
                subscription.type !== SUBSCRIPTION_TRIAL &&
                subscription.type !== SUBSCRIPTION_ENTERPRISE &&
                subscription.organizationSubscriptionStatus === 0
                  ? onCancelSubscription
                  : undefined
              }
              onChangePaymentMethod={
                !subscription.cancelAtPeriodEnd &&
                subscription.type !== SUBSCRIPTION_ENTERPRISE &&
                subscription.organizationSubscriptionStatus === 0 &&
                subscription.stripeSubscriptionId !== undefined &&
                subscription.stripeSubscriptionId !== ''
                  ? onChangePaymentMethod
                  : undefined
              }
            />
          </Col>
        </Row>
      </div>
    );
  },
);

export default SubscriptionSettingsUI;
